<template>
    <!-- 轮盘锦鲤 -->
    <div class="roulette-koi"
        :style="{background: bgColor}">
        <div class="lottery-wrapper"
            :style="{'background-image': `url(${bannerPic})`}">
            <!-- 获奖名单轮播--上方 -->
            <winner-list v-if="winnerScrollBarShow"
                :winnerList="winnerList"
                :tigerLottery="tigerLottery"
                :activityObj="activityObj"></winner-list>
            <!--轮盘锦鲤，第二节，中间抽奖区域-->
            <div class="section-two"
                :style="turnplateStyle">
                <!--老虎机-->
                <tigerMachineLottery ref="tigerMachineDraw"
                    :tips="tips"
                    :activityInfo="activityObj"
                    :awardPool="bigWheelRewardList"
                    :drawChances="Number(participateTimes)"
                    :pointDrawFlag="pointDrawFlag"
                    :activityStatus="Number(activityStatus)"
                    :userBase="userBase"
                    :drawType="drawType"
                    :drawStatus="drawStatus"
                    :pageDisplayContent="pageDisplayContent"
                    :tipsMessage="tipsMessage"
                    :isLoginFlag="isLoginFlag"
                    :loginType="loginType"
                    :activityUrl="activityUrl"
                    @noChance="noChanceMixin"
                    @startTigerMachine="pointer"
                    @endTigerMachine="tigerMachineWinningHandler"></tigerMachineLottery>
            </div>
        </div>
        <!-- 我的奖品，中奖名单 -->
        <reward-query :tigerLottery="tigerLottery"
            :miniprogramFlag="miniprogramFlag"
            :activityObj="activityObj"
            :miniType="miniType"
            :loginType="loginType"
            @goWinnerList="goWinnerList"
            @goHiHonorMiniProgram="goHiHonorMiniProgram"></reward-query>
        <!-- 奖品池 -->
        <prize-pool :sectionThreeColor="sectionThreeColor"
            :tigerLottery="tigerLottery"
            :awardNum="awardNum"
            :bigWheelRewardList="bigWheelRewardList"
            :classOption="classOption"
            class="prize-pool"></prize-pool>
        <!-- 会员信息和中奖记录（共用） -->
        <member-and-winning :memberInfo="memberInfo"
            :bigWheelActivityType="bigWheelActivityType"
            :tigerLottery="tigerLottery"
            :sectionThreeColor="sectionThreeColor"
            :myRecords="myRecords"
            :pointsValue="pointsValue"
            @viewRecord="viewRecord"
            @nextStep="nextStep"></member-and-winning>
        <!-- 活动规则 -->
        <activity-rules :bigWheelRewardList="bigWheelRewardList"
            :bigWheelActivityType="bigWheelActivityType"
            :tigerLottery="tigerLottery"
            :sectionThreeColor="sectionThreeColor"
            :ruleDesci="ruleDesci"></activity-rules>
    </div>
</template>
<script>
import memberAndWinning from '../../components/member-and-winning.vue';
import rewardQuery from '../../components/reward-query.vue';
import activityRules from '../../components/activity-rules.vue';
import winnerList from '../../components/winner-list.vue';
import prizePool from '../../components/prize-pool.vue';
import tigerMachineLottery from './components/tigerMachineLottery.vue';
import mixins from '../../mixin';
import { BigWheelConstants as BWC } from '../../common/global-variable';

export default {
  components: {
    memberAndWinning,
    rewardQuery,
    activityRules,
    winnerList,
    prizePool,
    tigerMachineLottery,
  },
  mixins: [mixins],
  props: {
    bgColor: String,
    bannerPic: String,
    tigerLottery: Boolean,
    tigerBgColor: String,
    activityObj: Object,
    bigWheelRewardList: Array,
    participateTimes: Number,
    pointDrawFlag: Boolean,
    activityStatus: String,
    drawType: String,
    miniprogramFlag: Boolean,
    loginType: String,
    miniType: String,
    winnerList: Array,
    bigWheelActivityType: String,
    ruleDesci: String,
    sectionThreeColor: String,
    pointsValue: String,
    memberInfo: Object,
    myRecord: Array,
    awardNum: Number,
    classOption: Object,
    activityUrl: String,
    userBase: Object,
    myRecords: Array,
    tips: String,
    isLoginFlag: Boolean,
    // 用户的抽奖状态
    drawStatus: {
      type: String,
      default: '',
    },
    // 页面展示文案
    pageDisplayContent: {
      type: String,
      default: '',
    },
    // 弹窗提示语
    tipsMessage: {
      type: String,
      default: '',
    },
    // 弹框提示语对应code
    tipsMessageCode: {
      type: Number,
      default: null,
    },
  },
  computed: {
    // 中奖信息滚动栏是否显示
    winnerScrollBarShow() {
      return this.activityObj.prizeWinningScrollFlag == BWC.prizeWinningScrollFlag.display && this.winnerList.length > 0;
    },
    turnplateStyle() {
      return {
        'padding-top': this.winnerScrollBarShow ? '202px' : '260px',
        background: this.tigerBgColor,
      };
    },
  },
  methods: {
    pointer() {
      this.$emit('pointer');
    },
    tigerMachineWinningHandler(e) {
      this.$emit('tigerMachineWinningHandler', e);
    },
    viewRecord(item) {
      this.$emit('viewRecord', item);
    },
    openGuide() {
      this.$emit('openGuide');
    },
    goWinnerList() {
      this.$emit('goWinnerList');
    },
    goHiHonorMiniProgram(e) {
      this.$emit('goHiHonorMiniProgram', e);
    },
    noChanceMixin(message) {
      if (this.tipsMessageCode === 1501 || this.tipsMessageCode === 1502) {
        this.$emit('updateIsShowIdentityDialog');
      } else {
        // 有传message以回调参数为主，没有则取后端返回的
        this.noChance(message || this.tipsMessage);
      }
    },
    nextStep(link, type) {
      this.$emit('nextStep', link, type);
    },
  },
};
</script>
<style scoped lang='scss'>
.roulette-koi {
  width: 100vw;
  .lottery-wrapper {
    width: 100%;
    height: 173.333vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .prize-pool {
    margin-top: -30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/roulette-koi/roulette-koi.vue